import { PeerStrategyManager } from "./PeerStrategyManager";
import { ScreenshareManager } from "./localMedia/ScreenshareManager";
import { AudioManager } from "./localMedia/AudioManager";
import { VideoManager } from "./localMedia/VideoManager";
export class VideoSystem {
    static instance = new VideoSystem();
    peerManager = new PeerStrategyManager();
    localAudio = new AudioManager();
    localVideo = new VideoManager(this.peerManager);
    localScreenshare = new ScreenshareManager();
    constructor() {
        Object.assign(window, { videoSystem: this });
    }
}
export const videoSystem = VideoSystem.instance;
//# sourceMappingURL=VideoSystem.js.map